import styles from './StudyCard.module.css';

interface StudyCardProps {
  body: string;
  eyebrow: string;
  title: string;
}

export function StudyCard({ body, eyebrow, title }: StudyCardProps) {
  return (
    <article className={styles.card}>
      <p className={styles.eyebrow}>{eyebrow}</p>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.body}>{body}</p>
    </article>
  );
}
